/* eslint-disable max-len */
import 'react';

const SidebarRootAddSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <mask id="mask0_102_32238" style={{'maskType': 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
            <rect width="16" height="16" fill="#FF0606" />
        </mask>
        <g mask="url(#mask0_102_32238)">
            <path fillRule="evenodd" clipRule="evenodd" d="M8.49999 2.1665C8.49999 1.89036 8.27613 1.6665 7.99999 1.6665C7.72385 1.6665 7.49999 1.89036 7.49999 2.1665V7.49984H2.16666C1.89051 7.49984 1.66666 7.72369 1.66666 7.99984C1.66666 8.27598 1.89051 8.49984 2.16666 8.49984H7.49999V13.8332C7.49999 14.1093 7.72385 14.3332 7.99999 14.3332C8.27613 14.3332 8.49999 14.1093 8.49999 13.8332V8.49984H13.8333C14.1095 8.49984 14.3333 8.27598 14.3333 7.99984C14.3333 7.72369 14.1095 7.49984 13.8333 7.49984H8.49999V2.1665Z" fill="#11141A" />
        </g>
    </svg>
);
export default SidebarRootAddSvg;
